import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';

import {disableLoanAutomaticPaymentsRequest, fetchLoansActions} from '../ducks';
import { bindActionCreators } from 'redux';

import Button from 'antd/lib/button';
import Icon from 'antd/lib/icon';
import Progress from 'antd/lib/progress';
import Tag from 'antd/lib/tag';
import Alert from 'antd/lib/alert';

import {
  formatDate,
  formatDateTime,
  currencyFormatter,
  percentageFormatter,
} from '../../../common/utils/helpers';
import { getRpmn, getMonthlyPayment } from '../../../common/utils/mathHelpers';
import {
  loanActions,
  loanActionsT,
  loanStatus,
  loanStatusT,
  loanGoalsT,
  installmentStatus,
  accountRoles,
} from '../../../common/enums';
import DocumentsPanel from '../../../features/dashboard/components/DocumentsPanel';
import config from '../../../config';
import CalendarPanel from './CalendarPanel';
import { paymentStatus } from '../../../common/enums';
import PaymentsPanel from '../../../features/dashboard/components/PaymentsPanel';
import CardPaymentModal from '../../../common/modals/CardPaymentModal';
import WithdrawalModal from '../../../common/modals/WithdrawalModal';
import SignLoanInsuranceBlock from './SignLoanInsuranceBlock';
import SignPostFinancingBlock from './SignPostFinancingBlock';

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
      {
        fetchLoans: fetchLoansActions.request,
        disableLoanAutomaticPayments: disableLoanAutomaticPaymentsRequest,
      },
      dispatch
  ),
});


const getFirstUnpaidInstallment = ({ installments }) =>
  installments.find(i => i.status === installmentStatus.UNPAID);

const getLastInstallment = ({ installments }) => installments[installments.length - 1];

const getPayedInstallments = ({ installments }) =>
  installments.filter(i => i.status === installmentStatus.PAID);

const getUnpaidInstallments = ({ installments }) =>
  installments.filter(i => i.status === installmentStatus.UNPAID);

const getUnpaidInstallmentsLate = ({ installments }) =>
  installments.filter(i => i.status === installmentStatus.UNPAID && new Date(i.paymentDue) < new Date());

const getPayedProgress = ({ installments }, payedInstallments) =>
  installments.length > 0 ? payedInstallments.length / installments.length * 100 : 0;

const getAssignedPayments = (payments) =>
  payments.filter(p => p.status === paymentStatus.ASSIGNED_TO_LOAN);

const getUnpaidPenaltyFee = ({ penaltyFees }) =>
  penaltyFees.filter(i => (i.unpaidAmount > 0 && i.storno !== true));

@translate()
@connect(undefined, mapDispatchToProps)
export default class LoanItem extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    loan: PropTypes.object.isRequired,
    showSignLoanModal: PropTypes.func.isRequired,
    showConfirmLoanModal: PropTypes.func.isRequired,
    showSignLoanInsuranceModal: PropTypes.func.isRequired,
    showConfirmLoanInsuranceModal: PropTypes.func.isRequired,
  };

  state = {
    activePanel: '',
    paymentModalVisible: false,
    withdrawalModalVisible: false,
  };

  togglePayments = () => {
    this.setState({
      activePanel: this.state.activePanel === 'payments' ? '' : 'payments',
    });
  }

  toggleCalendar = () => {
    this.setState({
      activePanel: this.state.activePanel === 'calendar' ? '' : 'calendar',
    });
  };

  toggleDocuments = () => {
    this.setState({
      activePanel: this.state.activePanel === 'documents' ? '' : 'documents',
    });
  };

  toggleUserDocuments = () => {
    this.setState({
      activePanel: this.state.activePanel === 'user_documents' ? '' : 'user_documents',
    });
  }

  showSignModal = () => {
    this.props.showSignLoanModal(this.props.loan);
  };

  showSignInsuranceModal = () => {
    this.props.showSignLoanInsuranceModal(this.props.loan);
  };

  showConfirmModal = () => {
    this.props.showConfirmLoanModal(this.props.loan.id);
  };

  showConfirmInsuranceModal = () => {
    this.props.showConfirmLoanInsuranceModal(this.props.loan.id);
  };

  handlePaymentModalCancel = () => {
    this.setState({
      paymentModalVisible: false
    })
  }

  showPaymentModal = () => {
    this.setState({
      paymentModalVisible: true
    })
  }

  showWithdrawalModal = () => {
    this.setState({ withdrawalModalVisible: true });
  }

  handleWithdrawalModalCancel = () => {
    this.setState({ withdrawalModalVisible: false });
  }

  getFinalContractStatusText() {
    const { t } = this.props;
    return t('Vaša pôžička: Čaká na podpis nižšie uvedených zmlúv, podpisom súhlasíte s ich znením');
  }


  disableAutomaticPayments = async () => {
    const { actions, loan } = this.props;
    const tt = await actions.disableLoanAutomaticPayments({loanId: loan.id});
    document.documentElement.scrollTop = 0;
    window.location.reload();
  }

  renderStatus() {
    const { loan, t } = this.props;
    //console.log('loan action:' + loan.amount, loan.action)

    let values = [loanStatus.UP1, loanStatus.UP2, loanStatus.ODP];
    let status = values.includes(loan.status) ? <Tag>{loanStatusT[loanStatus.AKT]}</Tag> : <Tag>{loanStatusT[loan.status]}</Tag>;

    if (loan.status === loanStatus.AUT) {
      status = <Tag>{loanStatusT[loanStatus.SCH]}</Tag>
    }
    if (loan.status === loanStatus.PRESCORING_FAILED) {
      status = <div>
                <Tag>{loanStatusT[loanStatus.PRESCORING_FAILED]}</Tag>
                <p>{t('Je nám ľúto, ale Vaša žiadosť bola zamietnutá, keďže nespĺňa potrebné požiadavky na získanie pôžičky.')}</p>
              </div>;
    }

    if (loan.action) {
      switch (loan.action) {
        case loanActions.SIGN_CONTRACT:
          status = (
            <div>
              <div className="loanActionButton" size="small" type="primary" ghost>
                {loan.insurance ? loanActionsT[loanActions.SIGN_CONTRACT_WITH_INSURANCE] : loanActionsT[loan.action]}
              </div>
            </div>
          );
          break;
        case loanActions.SIGN_INSURANCE_CONTRACT:
          status = (
                <div>
                  <div className="loanActionButton" size="small" type="primary" ghost>
                    {loanActionsT[loan.action]}
                  </div>
                  <SignLoanInsuranceBlock loan={loan}/>
                </div>
              );
          break;
        case loanActions.ENTER_SMS_CODE_CONTRACT:
          status = (
            <Button className="loanActionButton" size="small" type="primary" ghost onClick={this.showConfirmModal}>
              {loanActionsT[loan.action]}
            </Button>
          );
          break;
        case loanActions.ENTER_SMS_CODE_INSURANCE_CONTRACT:
          status = (
            <Button className="loanActionButton" size="small" type="primary" ghost onClick={this.showConfirmInsuranceModal}>
              {loanActionsT[loan.action]}
            </Button>
          );
          break;
        case loanActions.UPLOAD_BANK_ACCOUNT_STATEMENTS:
          status = 
            (<Button className="loanActionButton" size="small" type="primary" ghost>
              <Link to='/dashboard/documents'>
                {loanActionsT[loan.action]}
              </Link>
            </Button>);
          break;

        case loanActions.WAIT_FOR_CONFIRMATION:
          status = (
              <div className="loanActionButton" size="small" type="primary">
                {t('Ďakujeme za Vašu žiadosť o pôžičku. Vaša žiadosť sa momentálne overuje a vyhodnotená bude po telefonickom rozhovore s Vami. O výsledku budete tiež informovaný e-mailom. Následne si znova načítajte stránku alebo sa nanovo prihláste do Vašej klientskej zóny. ')}
                <Link to='/'>
                  <span style={{ textDecoration: 'underline' }}>
                    {`${t('Prípadne kliknite na tento link.')}`}
                  </span>
              </Link>
              </div>
          );
          break;
        case loanActions.SIGN_INFO_OBLIGATIONS:
        case loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS:
          // Single CTA owner = SignPendingContracts dashboard banner; suppress duplicate in loan card.
          status = null;
          break;
        default:
          status = <Tag>{loanActionsT[loan.action]}</Tag>;
      }
    }

    if (
      loan.status === loanStatus.WAITING_CONTRACT_SIGNATURE ||
      loan.status === loanStatus.CONTRACT_SIGNATURE_PENDING
    ) {
      // Cutover/migration path: debtor reached status 26/27 before IPK was signed.
      // When the backend signals SIGN_INFO_OBLIGATIONS or ENTER_SMS_CODE_INFO_OBLIGATIONS
      // the IPK signing block (owned by the dashboard SignPendingContracts banner) must
      // take over — do NOT render SignPostFinancingBlock until IPK is confirmed.
      const isIpkAction = (
        loan.action === loanActions.SIGN_INFO_OBLIGATIONS ||
        loan.action === loanActions.ENTER_SMS_CODE_INFO_OBLIGATIONS
      );
      if (!isIpkAction) {
        status = (
          <div>
            <div className="loanActionButton">
              {loan.status === loanStatus.WAITING_CONTRACT_SIGNATURE
                ? this.getFinalContractStatusText()
                : loanStatusT[loan.status]}
            </div>
            <SignPostFinancingBlock
              loan={loan}
              initialPhase={
                loan.status === loanStatus.CONTRACT_SIGNATURE_PENDING
                  ? 'confirm'
                  : undefined
              }
            />
          </div>
        );
      }
    }

    return status;
  }

  renderProgress() {
    const { t, loan } = this.props;

    if (loan.installments.length === 0) {
      return null;
    }

    if (loan.status === loanStatus.POOD) {
      return null;
    }
    const payedInstallments = getPayedInstallments(loan);
    const payedProgress = getPayedProgress(loan, payedInstallments);

    return (
      <div>
        <Row between="xs">
          <Col xs={12} className="progress-title">
            <p>{t('Progres splatenia')}</p>
            <p>
              {payedInstallments.length} / {loan.installments.length} {t('splátok')}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Progress percent={payedProgress} showInfo={false} />
          </Col>
        </Row>
      </div>
    );
  }

  renderButtons() {
    const { loan, t } = this.props;
    const payments = getAssignedPayments(loan.payments);

    if (loan.installments.length === 0 && loan.contracts.length === 0) {
      return null;
    }

    if (
      loan.action === loanActions.SIGN_CONTRACT ||
      loan.action === loanActions.ENTER_SMS_CODE_CONTRACT ||
      loan.status === loanStatus.NPI
    ) {
      return null;
    }

    return (
      <div className="loan-actions">
        {loan.status !== loanStatus.POOD && (
          <React.Fragment>
            {payments.length > 0 && (
              <Link onClick={this.togglePayments}>
                <Icon type="credit-card" />
                {t('Platby')}
              </Link>
            )}
            {loan.installments.length > 0 && (
              <Link onClick={this.toggleCalendar}>
                <Icon type="calendar" />
                {t('Kalendár splátok')}
              </Link>
            )}
            {loan.contracts.length > 0 && loan.status !== loanStatus.CNUD && (
              <Link onClick={this.toggleDocuments}>
                <Icon type="copy" />
                {t('Zmluvy')}
              </Link>
            )}
          </React.Fragment>
        )}
        {loan.status === loanStatus.POOD && (
          <Link onClick={this.toggleDocuments}>
            <Icon type="copy" />
            {t('Zmluvy')}
          </Link>
        )}
        {
          loan.documents && loan.documents.documents.length > 0 &&
          <Link onClick={this.toggleUserDocuments}>
            <Icon type="copy" />
              {t('Dokumenty')}
          </Link>
        }
      </div>
    );
  }

  renderPaymentsPanel() {
    const { loan, role } = this.props;
    const { activePanel } = this.state;
    const payments = getAssignedPayments(loan.payments);

    if (activePanel !== 'payments' || payments.length === 0) {
      return null;
    }

    return (
      <PaymentsPanel payments={payments} togglePayments={this.togglePayments} role={role} />
    );
  }

  renderCalendarPanel() {
    const { loan } = this.props;
    const { activePanel } = this.state;

    if (activePanel !== 'calendar' || loan.installments.length === 0) {
      return null;
    }

    const firstUnpaidInstallment = getFirstUnpaidInstallment(loan);

    return (
      <CalendarPanel
        installments={loan.installments}
        firstUnpaidInstallment={firstUnpaidInstallment}
        toggleCalendar={this.toggleCalendar}
      />
    );
  }

  renderDocumentsPanel() {
    const { loan, t } = this.props;
    const { activePanel } = this.state;

    if (activePanel !== 'documents' || loan.contracts.length === 0) {
      return null;
    }

    return (
      <DocumentsPanel
        title={t('Zmluvy')}
        contracts={loan.contracts}
        toggleDocuments={this.toggleDocuments}
        accountRole={accountRoles.DEBTOR}
      />
    );
  }

  renderUserDocuments() {
    const { loan, t } = this.props;
    const { activePanel } = this.state;

    if (activePanel !== 'user_documents' || !loan.documents) {
      return null;
    }

    const userDocuments = loan.documents.documents.map(doc => {
      return {
        id: doc.file.id,
        contractNumber: doc.file.name,
        fileId: doc.file.id,
        type: doc.type,
      }
    });

    return (
      <DocumentsPanel
        title={t('Používateľské dokumenty')}
        contracts={userDocuments}
        toggleDocuments={this.toggleUserDocuments}
        accountRole={accountRoles.DEBTOR}
      />
    );
  }

  render() {
    const { t, loan, loansNumber } = this.props;
    const item = localStorage.getItem(loan.id);
    let itemAlreadyRendered = false;
    if (!item) {
      localStorage.setItem(loan.id, true);
      itemAlreadyRendered = true;
    }
    let itemOutOfDate = false;
    let createdPlusOne = new Date(loan.createdAt);
    createdPlusOne.setDate(createdPlusOne.getDate() + 1);
    if (new Date() < createdPlusOne)
      itemOutOfDate = true;


    const firstUnpaidInstallment = getFirstUnpaidInstallment(loan);
    const lastInstallment = getLastInstallment(loan);
    const installmentsAmount = loan.installments.reduce(
      (sum, installment) => sum + parseFloat(installment.amount),
      0
    );
    const payedInstallmentsAmount = getPayedInstallments(loan).reduce(
      (sum, installment) => sum + parseFloat(installment.amount),
      0
    );
    const unpaidInstallmentsPartiallyPaidAmount = getUnpaidInstallments(loan).reduce(
      (sum, installment) => sum + parseFloat(installment.amount) - parseFloat(installment.principalUnpaid) - parseFloat(installment.interestUnpaid) - parseFloat(installment.insuranceUnpaid),
      0
    );
    const lateInstallmentsUnpaidAmount = getUnpaidInstallmentsLate(loan).reduce(
      (sum, installment) => sum + parseFloat(installment.principalUnpaid) + parseFloat(installment.interestUnpaid) + parseFloat(installment.insuranceUnpaid),
      0
    );
    const penaltyFee = getUnpaidPenaltyFee(loan).reduce(
      (sum, penalty) => sum + parseFloat(penalty.unpaidAmount),
      0
    );

    const loanAmount = parseFloat(loan.amount);
    const loanInterest = parseFloat(loan.interest);
    const hasInsurance = !!loan.insurance;

    const insuranceAmountPerMonth = lastInstallment
      ? parseFloat(lastInstallment.insuranceAmount || 0)
      : (loan.insuranceInfo && typeof loan.insuranceInfo.insuranceAmount === 'number' && loan.insuranceInfo.insuranceAmount > 0
          ? loan.insuranceInfo.insuranceAmount
          : 0);

    const basePayment = lastInstallment
      ? parseFloat(lastInstallment.amount) - insuranceAmountPerMonth
      : (loanInterest
          ? getMonthlyPayment(loanAmount, loan.months, loanInterest)
          : (loan.months > 0 ? parseFloat((loanAmount / loan.months).toFixed(2)) : 0));

    const rpmnValue = (basePayment > 0 && loan.months > 0)
      ? getRpmn(loanAmount, basePayment, loan.months)
      : 0;

    const totalPayment = basePayment + insuranceAmountPerMonth;
    const totalRepayment = totalPayment * loan.months;
    const headerActions = this.renderButtons();

    return (
      <div className="item-wrapper">
        <div className="loan-header">
          <div className="loan-header-content">
            <h2>
              {[loanStatus.NPI, loanStatus.NEP, loanStatus.POD].includes(loan.status)
                ? t('Žiadosť o pôžičku na')
                : t('Pôžička na')}{' '}
              "{loanGoalsT[loan.goal]}"
            </h2>
            {this.renderStatus()}
          </div>
          {headerActions && (
            <div className="loan-header-actions">
              {headerActions}
            </div>
          )}
        </div>
        <Row>
          <Col xs={12} sm={6} className="loan-information">
            {loan.status === loanStatus.POOD && (
              <div>
                <p>
                  <strong>{t('Pôžička odpredaná na vymáhanie')}</strong>
                </p>
              </div>
            )}
            <div>
              <p>{t('Účel')}:</p>
              <p>
                <strong>{t('Pôžička na')} "{loanGoalsT[loan.goal]}"</strong>
              </p>
            </div>
            <div>
              <p>{t('Pôžička')}:</p>
              <p>
                <strong>{currencyFormatter(loan.amount)}</strong>
              </p>
            </div>
            <div>
              <p>{t('Splatnosť')}:</p>
              <p>
                <strong>{loan.months} {t('mes.')}</strong>
              </p>
            </div>
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Úrok')}:</p>
                <p>
                  <strong>{percentageFormatter(loan.interest)} p.a.</strong>
                </p>
              </div>
            )}
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && basePayment > 0 && (
              <div>
                <p>{t('RPMN')}:</p>
                <p>
                  <strong>{percentageFormatter(rpmnValue)}</strong>
                </p>
              </div>
            )}
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && hasInsurance && insuranceAmountPerMonth > 0 && (
              <div>
                <p>{t('Poistenie')}:</p>
                <p>
                  <strong>{currencyFormatter(insuranceAmountPerMonth)} / {t('mes.')}</strong>
                </p>
              </div>
            )}
            {loan.insurance && basePayment > 0 && (![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Splátka')}:</p>
                <p>
                  <strong>{currencyFormatter(basePayment)} / {t('mes.')}</strong>
                </p>
              </div>
            )}
            {basePayment > 0 && loan.status !== loanStatus.POOD && (
              <div>
                <p>{loan.insurance ? t('Splátka + poistenie') : t('Splátka')}:</p>
                <p>
                  <strong>{currencyFormatter(totalPayment)} / {t('mes.')}</strong>
                </p>
              </div>
            )}
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Poplatok')}:</p>
                <p>
                  <strong>{currencyFormatter(loan.ProvisionFee)}</strong>
                </p>
              </div>
            )}
            {basePayment > 0 && loan.status !== loanStatus.POOD && (
              <div>
                <p>{t('Spolu zaplatíte')}:</p>
                <p>
                  <strong>{currencyFormatter(totalRepayment)}</strong>
                </p>
              </div>
            )}
            {loan.status === loanStatus.SCH && (
              <div>
                <p>{t('Ostáva do zaplnenia')}:</p>
                <p>
                  <strong>{currencyFormatter(loan.remainingAmount)}</strong>
                </p>
              </div>
            )}
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Celkový dlh')}:</p>
                <p>
                  <strong>{currencyFormatter(installmentsAmount - payedInstallmentsAmount - unpaidInstallmentsPartiallyPaidAmount + penaltyFee)}</strong>
                </p>
              </div>
            )}
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Aktuálny dlh')}:</p>
                <p>
                  <strong>{currencyFormatter(lateInstallmentsUnpaidAmount + penaltyFee)}</strong>
                </p>
              </div>
            )}
            {firstUnpaidInstallment && loan.status !== loanStatus.POOD && (
              <div>
                <p>{t('Najbližšia splátka')}:</p>
                <p>
                  <strong>{formatDate(firstUnpaidInstallment.paymentDue)}</strong>
                </p>
              </div>
            )}
            {(![loanStatus.POOD, loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Neuhradené sankčné poplatky')}:</p>
                <p>
                  <strong>{currencyFormatter(penaltyFee)}</strong>
                </p>
              </div>
            )}
            {lastInstallment && loan.status !== loanStatus.POOD && (
              <div>
                <p>{t('Predpokladané splatenie')}:</p>
                <p>
                  <strong>{formatDate(lastInstallment.paymentDue)}</strong>
                </p>
              </div>
            )}
            <div>
              <p>{t('Dátum vytvorenia')}:</p>
              <p>
                <strong>{formatDateTime(loan.createdAt)}</strong>
              </p>
            </div>
            {loan.installments.length === 0 && (![loanStatus.PRESCORING_FAILED].includes(loan.status)) && (
              <div>
                <p>{t('Dátum platnosti')}:</p>
                <p>
                  <strong>{formatDateTime(loan.expirationDate)}</strong>
                </p>
              </div>
            )}

            {loan.status !== loanStatus.POOD && loan.installments.length > 0 && <h3>{t('Info k platbe')}</h3>}
            {loan.status !== loanStatus.POOD && loan.loanNumber && loan.installments.length > 0 && (
              <div>
                <p>{t('Číslo účtu')}:</p>
                <p>
                  <strong>{config.IBAN}</strong>
                </p>
              </div>
            )}
            {loan.status !== loanStatus.POOD && loan.loanNumber && loan.installments.length > 0 && (
              <div>
                <p>{t('Variabilný symbol')}:</p>
                <p>
                  <strong>{loan.loanNumber}</strong>
                </p>
              </div>
            )}
          </Col>
          <Col xs={12} sm={6} className="item-right payment-button-parent">
            {this.renderProgress()}

            {loan.canWithdraw && (
              <div style={{ marginBottom: 8 }}>
                <Button
                  size="default"
                  className="btn-inline"
                  type="danger"
                  onClick={this.showWithdrawalModal}
                  style={{ float: 'right' }}
                >
                  {t('Odstúpenie od Rámcovej zmluvy')}
                </Button>
                <WithdrawalModal
                  loan={loan}
                  visible={this.state.withdrawalModalVisible}
                  onCancel={this.handleWithdrawalModalCancel}
                />
              </div>
            )}

            {[loanStatus.AKT, loanStatus.UP1, loanStatus.UP2, loanStatus.UP3, loanStatus.ODP].includes(loan.status) && loan.loanNumber && loan.installments.length > 0 && (
              <div>

                {loan.automaticPayments &&
                  <div  data-show="true" className="ant-alert ant-alert-info ant-alert-with-description">
                    <i className="anticon anticon-info-circle-o ant-alert-icon"></i>
                    <span className="ant-alert-message">
                      {`Zapnuté automatické splátky z uloženej karty číslo ` + loan.automaticPayments.card + ` s dobou expirácie ` + loan.automaticPayments.expiration +`. `}
                      <Link onClick={this.disableAutomaticPayments}>
                        <span style={{ textDecoration: 'underline' }}>
                          {`${t('(Vypnúť automatické splátky)')}`}
                        </span>
                      </Link>
                    </span>
                  </div>
                }

                {!loan.automaticPayments &&
                  <div  data-show="true" className="ant-alert ant-alert-info ant-alert-with-description" style={{background: '#f7f7f7', 'border-color': '#ccc', opacity: '80%'}}>
                    <i className="anticon anticon-info-circle-o ant-alert-icon"></i>
                    <span className="ant-alert-message">
                      {`Automatické splátky nie sú zapnuté. Automatické splátky z uloženej karty si môžete zapnúť pri realizácii platby kartou.`}
                    </span>
                  </div>
                }

                <Button size='default' className='btn-inline' type='primary' onClick={this.showPaymentModal} style={{ float: 'right' }}>
                  Platba kartou
                </Button>
                <CardPaymentModal
                  maxPayment={Number((installmentsAmount - payedInstallmentsAmount - unpaidInstallmentsPartiallyPaidAmount + penaltyFee).toFixed(2))}
                  currentDebt={lateInstallmentsUnpaidAmount + penaltyFee}
                  visible={this.state.paymentModalVisible}
                  handleModalCancel={this.handlePaymentModalCancel}
                  loan={loan}
                >
                </CardPaymentModal>

              </div>
            )}
          </Col>
        </Row>



        {this.renderPaymentsPanel()}
        {this.renderCalendarPanel()}
        {this.renderDocumentsPanel()}
        {this.renderUserDocuments()}
        {loan.status === loanStatus.NPI && itemAlreadyRendered && itemOutOfDate && loansNumber < 2 &&
          <img
            src={`https://www.totalmoney.sk/index.php?option=com_ziadosti&typ_ziadosti=315&task=px_insert&format=raw&transaction_id=${loan.loanNumber}&utmt=${localStorage.getItem('utm_source')}`}
            alt="" style={{ width: 1, height: 1, display: 'none' }}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/LoanItem.js